<div class="spinner-wrapper">
    <div class="loading-shade" *ngIf="isFormLoading">
        <div class="loading-spinner"></div>
    </div>
</div>
<form class="customer-form-container" [formGroup]="form" [class.form-loading]="isFormLoading">
    <div class="customer-form-top-container">
        <div class="customer-form-column">
            <div class="custom-box customer-form-header">
                <div class="custom-box-inner">
                    General Information
                </div>
            </div>
            <div class="custom-box customer-form-section-content">
                <div class="customer-form-row">
                    <div>Customer Name*</div>
                    <custom-text-input formControlName="name" class="customer-input" [placeholder]="'Enter the name of the customer here'" [errorMessages]="errorMessageLists.name"/>
                </div>
                <div class="customer-form-row">
                    <div>Customer Type</div>
                    <lookup-manager class="customer-input" formControlName="customerTypeId" 
                        [defaultText]="'Select the customer type'" [lookupName]="'Customer Type'" [items]="customerTypes" [addNew]="addCustomerType" [edit]="editCustomerType" [delete]="deleteCustomerType"
                        (lookupsChanged)="refreshCustomerTypes()"/>
                </div>
                <div class="customer-form-row">
                    <div>Customer Instance URL*</div>
                    <lookup-manager formControlName="customerInstanceUrlId" class="customer-input"
                        [defaultText]="'Select the customer instance URL'" [lookupName]="'Customer Instance URL'" [items]="customerInstanceUrls" [addNew]="addCustomerInstanceUrl" 
                        [edit]="editCustomerInstanceUrl" [delete]="deleteCustomerInstanceUrl" (lookupsChanged)="refreshCustomerInstanceUrls()" [errorMessages]="errorMessageLists.customerInstanceUrl"/>
                </div>
                <div class="customer-form-row">
                    <div>Customer Contact</div>
                    <custom-text-input formControlName="contact" class="customer-input" [placeholder]="'Enter the customer contact email ID here'" [errorMessages]="errorMessageLists.contact"/>
                </div>
                <div class="customer-form-row">
                    <div>Integrator Name</div>
                    <custom-text-input formControlName="integratorName" class="customer-input" [placeholder]="'Enter the integrator name here'"/>
                </div>
                <div class="customer-form-row">
                    <div>Integrator Contact</div>
                    <custom-text-input formControlName="integratorContact" class="customer-input" [placeholder]="'Enter the integrator contact email ID here'" [errorMessages]="errorMessageLists.integratorContact"/>
                </div>
                <div class="customer-form-row">
                    <div>Tenant ID*</div>
                    <custom-text-input formControlName="tenantId" class="customer-input" [placeholder]="'Enter the tenant ID here'" [errorMessages]="errorMessageLists.tenantId"/>
                </div>

            </div>
        </div>
        <div class="customer-form-column">
            <div class="custom-box customer-form-header">
                <div class="custom-box-inner">
                    Subscription Details
                </div>
            </div>
            <div class="custom-box customer-form-section-content">
                <div class="customer-form-row">
                    <div>Enable Tenancy</div>
                    <label class="switch">
                        <input type="checkbox" formControlName="enabled" name="enable-tenancy">
                        <span class="slider round"></span>
                    </label>
                </div>
                <div class="customer-form-row" formGroupName="subscriptionDetails">
                    <div>Enable Cloud Services</div>
                    <label class="switch">
                        <input type="checkbox" formControlName="cloudServicesEnabled" name="enable-cloud-services">
                        <span class="slider round"></span>
                    </label>
                </div>
                <div class="customer-form-row">
                    <div>Creation Date</div>
                    <div class="customer-right-column-input">
                        <synx-date-time-input class="customer-date-picker" formControlName="createdDate"
                            format="date" [minDate]="dateLowerBound" [maxDate]="dateUpperBound"></synx-date-time-input>
                    </div>
                </div>
                <div class="customer-form-row">
                    <div>Subscription Start Date</div>
                    <div class="customer-right-column-input">
                        <synx-date-time-input class="customer-date-picker" formControlName="subscriptionStartDate"
                            format="date" [minDate]="dateLowerBound" [maxDate]="dateUpperBound"></synx-date-time-input>
                    </div>
                </div>
                <div class="customer-form-row">
                    <div>Contract Period</div>
                    <lookup-manager class="customer-right-column-input" formControlName="contractTerm" 
                        [defaultText]="'Select the Contract Term'" [addInputPlaceholder]="'Enter a term in years'" [lookupName]="'Contract Term'" [items]="contractTerms" [addNew]="addContractTerm" [edit]="editContractTerm" [delete]="deleteContractTerm"
                        (lookupsChanged)="refreshContractTerms()" [displayNameMapper]="contractTermDisplayNameMapper" [inputRegexValidations]="contractTermRegexValidations"/>
                </div>
                <div class="customer-form-row">
                    <div>Subscription End Date</div>
                    <div class="customer-right-column-input">
                        <synx-date-time-input class="customer-date-picker" formControlName="subscriptionEndDate"
                            format="date"></synx-date-time-input>
                    </div>
                </div>
                <div class="customer-form-row">
                    <div>PO Number</div>
                    <custom-text-input formControlName="poNumber" class="customer-right-column-input" [placeholder]="'Enter the PO number here'"/>
                </div>
            </div>
        </div>
    </div>
    <div class="customer-form-bottom-container">
        <div class="custom-box customer-form-header">
            <div class="custom-box-inner">
                Allowances
            </div>
        </div>
        <div class="allowances-container" formGroupName="subscriptionDetails">
            <div class="allowances-column custom-box">
                <img class="allowance-icon" src="assets/icons/vehicles.svg">
                <div class="allowance-label">
                    Assets
                    <div *ngIf="assetCount" class="allowance-subscript" [ngClass]="'warning-' + assetCountWarning">
                        {{assetCount}}
                    </div>
                </div>
                <custom-tooltip [tooltipMessage]="'Assets are the total number of assets available to configure in the subscription tenure.'">
                    <img class="help-icon" src="assets/icons/information-outline.svg" tooltip-hoverable>
                </custom-tooltip>
                <div class="allowances-error-anchor">
                    <input class="custom-input custom-numerical-input has-error-message" type="number" (keydown)="preventNonInteger($event)" name="assets-count" formControlName="assetLimit" min="0">
                    <div class="error-message customer-error">*Please enter a positive integer.</div>
                </div>

                <div class="allowances-divider"></div>

                <img class="allowance-icon" src="assets/icons/database.svg">
                <div class="allowance-label">
                    Storage (TB)
                    <div *ngIf="usageDetails" class="allowance-subscript" [ngClass]="'warning-' + usageDetails.blobStorageUsed?.warningLevel">
                        {{usageDetails.blobStorageUsed?.amount}}
                    </div>
                </div>
                <custom-tooltip [tooltipMessage]="'Storage is the total storage available for the subscription tenure. If exceeded will need a top up plan.'">
                    <img class="help-icon" src="assets/icons/information-outline.svg" tooltip-hoverable>
                </custom-tooltip>
                <div class="allowances-error-anchor">
                    <input class="custom-input custom-numerical-input has-error-message" type="number" (keydown)="preventNonInteger($event)" name="storage-count" formControlName="storageLimit" min="0">
                    <div class="error-message customer-error">*Please enter a positive integer.</div>
                </div>

                <div class="allowances-divider"></div>

                <img class="allowance-icon" src="assets/icons/group.svg">
                <div class="allowance-label">
                    Users
                    <div *ngIf="usageDetails" class="allowance-subscript" [ngClass]="'warning-' + usageDetails.loggedInUsers?.warningLevel">
                        {{usageDetails.loggedInUsers?.amount}}
                    </div>
                </div>
                <custom-tooltip [tooltipMessage]="'Users is the allowed total number of logged in users at a given point in time.'">
                    <img class="help-icon" src="assets/icons/information-outline.svg" tooltip-hoverable>
                </custom-tooltip>
                <div class="allowances-error-anchor">
                    <input class="custom-input custom-numerical-input has-error-message" type="number" (keydown)="preventNonInteger($event)" name="users-count" formControlName="concurrentUsersLimit" min="0">
                    <div class="error-message customer-error">*Please enter a positive integer.</div>
                </div>
            </div>
            <div class="allowances-column custom-box">
                <img class="allowance-icon" src="assets/icons/bulletlist.svg">
                <div class="allowance-label">
                    Incidents
                    <div *ngIf="usageDetails" class="allowance-subscript" [ngClass]="'warning-' + usageDetails.incidentsCreated?.warningLevel">
                        {{usageDetails.incidentsCreated?.amount}}
                    </div>
                </div>
                <custom-tooltip [tooltipMessage]="'Incidents are an aggregation of the monthly allowance for the entire subscription tenure. '">
                    <img class="help-icon" src="assets/icons/information-outline.svg" tooltip-hoverable>
                </custom-tooltip>
                <div class="allowances-error-anchor">
                    <input class="custom-input custom-numerical-input has-error-message" type="number" (keydown)="preventNonInteger($event)" name="incidents-count" formControlName="incidentCreationLimit" min="0">
                    <div class="error-message customer-error">*Please enter a positive integer.</div>
                </div>

                <div class="allowances-divider"></div>

                <img class="allowance-icon" src="assets/icons/camera.svg">
                <div class="allowance-label">
                    Stream Video (mins)
                    <div *ngIf="usageDetails" class="allowance-subscript" [ngClass]="'warning-' + usageDetails.minutesStreamed?.warningLevel">
                        {{usageDetails.minutesStreamed?.amount}}
                    </div>
                </div>
                <div class="allowance-additional-controls">
                    <custom-tooltip [tooltipMessage]="'Stream Video minutes are fixed number of minutes that renew monthly.'">
                        <img class="help-icon" src="assets/icons/information-outline.svg" tooltip-hoverable>
                    </custom-tooltip>
                    <custom-tooltip [tooltipMessage]="'Toggle whether stream video is enabled for this customer. Please note Cloud Services must be enabled for this customer to enable stream video.'">
                        <label class="switch" tooltip-hoverable>
                            <input type="checkbox" formControlName="streamVideoEnabled" name="stream-video-enabled">
                            <span class="slider round"></span>
                        </label>
                    </custom-tooltip>
                </div>
                <div class="allowances-error-anchor">
                    <input class="custom-input custom-numerical-input has-error-message" type="number" (keydown)="preventNonInteger($event)" name="video-count" formControlName="liveVideoLimit" min="0">
                    <div class="error-message customer-error">*Please enter a positive integer.</div>
                </div>

                <div class="allowances-divider"></div>

                <img class="allowance-icon" src="assets/icons/seatbelt.svg">
                <div class="allowance-label">
                    Redaction (mins)
                    <div *ngIf="usageDetails" class="allowance-subscript" [ngClass]="'warning-' + usageDetails.secondsRedacted?.warningLevel">
                        {{usageDetails.secondsRedacted?.amount}}
                    </div>
                </div>
                <div class="allowance-additional-controls">
                    <custom-tooltip [tooltipMessage]="'Redaction minutes are fixed number of minutes that renew monthly.'">
                        <img class="help-icon" src="assets/icons/information-outline.svg" tooltip-hoverable>
                    </custom-tooltip>
                    <custom-tooltip [tooltipMessage]="'Toggle whether redaction is enabled for this customer. The trial dates below grant it temporarily instead, so they are locked while this is on.'">
                        <label class="switch redaction-enabled-toggle" tooltip-hoverable>
                            <input type="checkbox" formControlName="redactionEnabled" name="redaction-enabled">
                            <span class="slider round"></span>
                        </label>
                    </custom-tooltip>
                </div>
                <div class="allowances-error-anchor">
                    <input class="custom-input custom-numerical-input has-error-message" type="number" (keydown)="preventNonInteger($event)" name="redaction-count" formControlName="redactionLimit" min="0">
                    <div class="error-message customer-error">*Please enter a positive integer.</div>
                </div>

                <div class="redaction-trial-row">
                    <div class="redaction-trial-field">
                        <span class="allowance-label">Trial Start</span>
                        <div class="redaction-trial-date">
                            <synx-date-time-input class="customer-date-picker" formControlName="redactionTrialStartedAt"
                                format="date"></synx-date-time-input>
                        </div>
                    </div>
                    <div class="redaction-trial-field">
                        <span class="allowance-label">Trial Expiry</span>
                        <div class="redaction-trial-date">
                            <synx-date-time-input class="customer-date-picker" formControlName="redactionTrialExpiresAt"
                                format="date"></synx-date-time-input>
                        </div>
                    </div>
                    <button type="button" class="clear-trial-button" *ngIf="canClearTrialWindow" (click)="clearTrialWindow()">
                        <img src="assets/icons/close.svg" alt="">
                        Clear Trial
                    </button>
                    <custom-tooltip [tooltipMessage]="'Customers start their own 7 day trial from the Cloud Evidence Locker. These dates override it: clear them to let the customer trial again, or move the window to extend it, up to 14 days at a time. A trial cannot be dated to start later.'">
                        <img class="help-icon" src="assets/icons/information-outline.svg" tooltip-hoverable>
                    </custom-tooltip>
                </div>
                <div class="redaction-trial-error" *ngIf="trialWindowError">{{trialWindowError}}</div>

                <div class="allowances-divider"></div>

                <img class="allowance-icon" src="assets/icons/progress-upload.svg">
                <div class="allowance-label">
                    XBA Transcode (mins)
                    <div *ngIf="usageDetails" class="allowance-subscript" [ngClass]="'warning-' + usageDetails.xbaTranscodeMinutes?.warningLevel">
                        {{usageDetails.xbaTranscodeMinutes?.amount}}
                    </div>
                </div>
                <custom-tooltip [tooltipMessage]="'XBA transcode minutes are a fixed number of minutes that renew monthly. Every clip a transcode produces counts, so ten one hour clips uses six hundred minutes. Set this to 0 for a customer without XBA transcoding.'">
                    <img class="help-icon" src="assets/icons/information-outline.svg" tooltip-hoverable>
                </custom-tooltip>
                <div class="allowances-error-anchor">
                    <input class="custom-input custom-numerical-input has-error-message" type="number" (keydown)="preventNonInteger($event)" name="xba-transcode-count" formControlName="xbaTranscodeLimit" min="0">
                    <div class="error-message customer-error">*Please enter a positive integer.</div>
                </div>
            </div>
        </div>
    </div>
</form>
